window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


// Svjezi iznosi jackpota s RestApi-ja: {CasinoRestApiUrl}/jackpots (polja: id, pid, bid, n, i).
// URL i kljuc se citaju iz postavki iz baze (casino.config.casinoRestApiUrl / casinoRestApiKey).
// Koristi se za: igru (igra.jpId -> id), banere (pid) i provider stranicu (bid).
repos.activeJackpotsRepo = function () {

    var get = function () {

        var restApiUrl = casino.config.casinoRestApiUrl;

        // Bez postavke nema poziva - tada klijent NE prikazuje jackpot iznose
        // (nema fallbacka na stare liste ni na kechirani igra.jp).
        if (!restApiUrl) {
            return Promise.resolve(null);
        }

        // Nekritican podatak: na gresku vracamo null (bez fatalnog network overlaya).
        // Napomena: RestApi je druga domena pa se ne salju kolacici - autorizacija ide preko ApiKey headera.
        return fetch(restApiUrl.replace(/\/+$/, '') + '/jackpots', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'ApiKey': casino.config.casinoRestApiKey || ''
            }
        })
            .then(function (response) {
                return response.ok ? response.json() : null;
            })
            .catch(function () {
                return null;
            });

    };

    return {
        get: get
    }

}();
